import { useEffect } from 'react';
import TagManager from 'react-gtm-module';

export interface GTMProps {
  gtmId: string;
  dataLayerName: string;
}

const GTMInitialize = ({ gtmId, dataLayerName }: GTMProps) => {
  useEffect(() => {
    TagManager.initialize({ gtmId, dataLayerName });
  }, [gtmId, dataLayerName]);

  return null;
};

export default GTMInitialize;
